import React from 'react'
import { Link } from "gatsby"
import tw from "twin.macro"
//import Layout from '../layouts/default'
import SEO from "../utils/seo"

import Pill from '@ui-kit/atoms/button/pill'

import PageLayout from '../layouts/page'

import QuickLinks from '../quick-links'

type SceneProps = {
    otherTerms: any,
    kbItems: Array<any>,
    title: string
}

const Scene = (
    {
        otherTerms,
        kbItems,
        title,
    ...props
}: SceneProps) => {

    return (
            <PageLayout>
                <aside>
                    <dl>
                        <dt>Other Categories</dt>
                        <dd>
                            <ul tw="gap-3! md:gap-2!">
                                { otherTerms?.map(tag => tag.path && (
                                    <li tw="m-0" key={tag.tid}>
                                        <Link activeClassName={'is-active'} to={tag.path.alias}>
                                            <Pill silver elem="span" className="wrapped">{tag.title}</Pill>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </dd>
                    </dl>
                </aside>
                <section>
                    <article itemScope>
                        <h1 itemProp="headline">{title}</h1>
                    </article>
                    {kbItems.length > 0 ? <QuickLinks style={{marginTop:'2em'}} items={kbItems} compact={true} /> : ''}
                </section>
            </PageLayout>
    )
}

export default Scene
